var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.CollectibleIndicator = function() {
    EHDI.aka.Container.call(this);
};

EHDI.game.CollectibleIndicator.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.CollectibleIndicator.prototype.init = function () {
  this._active;
  this._sprite;
  this._textContainer;
  this._text1;
  this._text2;
  this._animation;

  if (this._sprite == null) {
    this._sprite = new EHDI.aka.Sprite(EHDI.Assets.images["pickup1"]);
    this._sprite.anchor.set(0.5,0.5);

    this.addChild(this._sprite);
  }

  if (this._textContainer == null) {
    this._textContainer = new EHDI.aka.Container();

    this.addChild(this._textContainer);
  }

  if (this._text1 == null) {
    this._text1 = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_COL_MULTIPLIER1"));

    this._text1.anchor.x = 0.5;
    this._text1.anchor.y = 0.5;

    this._text1.position.set(0,-16);
    this._textContainer.addChild(this._text1);
  }

  if (this._text2 == null) {
    this._text2 = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("STR_COL_MULTIPLIER2"));

    this._text2.anchor.x = 0.5;
    this._text2.anchor.y = 0.5;

    this._text2.position.set(0,16);
    this._textContainer.addChild(this._text2);
  }

  if (this._animation == null) {
    this._animation = new EHDI.game.Effect();
    this._animation.init('burst_fx');

    // this._animation.getDisplay().x = -100;
    this._animation.getDisplay().visible = false;
    this.addChild(this._animation.getDisplay());
  }

  this.visible = false;
  this._active = false;
  this._animateUp = false;
}

EHDI.game.CollectibleIndicator.prototype.isActive = function () {
  return this._active;
}

EHDI.game.CollectibleIndicator.prototype.spawn = function (collectibleCount) {
  if (collectibleCount == 0) {
    this._sprite.texture = EHDI.Assets.images["pickup1"];
    this._animationName = 'pickglow1';
    this._text1.text = EHDI.GAME.jsonManager.getLocale("STR_COL_MULTIPLIER1").TEXT;
    this._text2.text = EHDI.GAME.jsonManager.getLocale("STR_COL_MULTIPLIER2").TEXT;
  } else if (collectibleCount == 1) {
    this._sprite.texture = EHDI.Assets.images["pickup2"];
    this._animationName = 'pickglow2';
    this._text1.text = EHDI.GAME.jsonManager.getLocale("STR_COL_ADDITIONAL_DISC1").TEXT;
    this._text2.text = EHDI.GAME.jsonManager.getLocale("STR_COL_ADDITIONAL_DISC2").TEXT;
  } else if (collectibleCount == 2) {
    this._sprite.texture = EHDI.Assets.images["pickup3"];
    this._animationName = 'pickglow3';
    this._text1.text = EHDI.GAME.jsonManager.getLocale("STR_COL_BONUS1").TEXT;
    this._text2.text = EHDI.GAME.jsonManager.getLocale("STR_COL_BONUS2").TEXT;
  }

  this.scale.x = 0;
  this.scale.y = 0;
  this._active = true;
  this.visible = true;
  this._animation.getDisplay().visible = false;
  this._textContainer.alpha = 1;

  this._sprite.visible = true;

  this._tl1 = TweenLite.to(this.scale, 0.3,{x:1, y:1});
}

EHDI.game.CollectibleIndicator.prototype.explode = function () {
  EHDI.GAME.soundManager.playSFX("success");
  EHDI.GAME.soundManager.playSFX("pickup");
  this._active = false;
  this._sprite.visible = false;

  this._animation.getDisplay().x = this._sprite.x;
  this._animation.getDisplay().y = this._sprite.y;

  this._animation.changeAnimation(false, this._animationName);
  this._animation.getDisplay().visible = true;

  this._tl1 = TweenLite.to(this._textContainer, 1,{alpha:0});
  // this._tl1 = TweenLite.to(this._text1.position, 0.5,{y:this._text1.position.y - 20});
  // this._tl2 = TweenLite.to(this._text2.position, 0.5,{y:this._text2.position.y - 20});
}

EHDI.game.CollectibleIndicator.prototype.remove = function () {
  if (this._active) {
    EHDI.GAME.soundManager.playSFX("lose");

    this._active = false;
  }

  this._tl1 = TweenLite.to(this.scale, 0.3,{x:0, y:0});
}

EHDI.game.CollectibleIndicator.prototype.update = function () {
  if (this._active) {
    if (this._animateUp) {
      this.y -= 0.2;

      if (this.y <= 250) {
        this.y = 250;
        this._animateUp = false;
      }
    } else {
      this.y += 0.2;

      if (this.y >= 270) {
        this.y = 270;
        this._animateUp = true;
      }
    }

    this._textContainer.y = this._sprite.y;
  }
}
